import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  ", "\n  ", "\n  ", "\n  fragment OrderDetail on Order {\n    userEmail\n    paymentStatus\n    paymentStatusDisplay\n    status\n    statusDisplay\n    id\n    token\n    number\n    shippingAddress {\n      ...Address\n    }\n    lines {\n      selectedProductAttributes\n      productName\n      translatedProductName\n      quantity\n      variant {\n        ...ProductVariant\n      }\n      unitPrice {\n        currency\n        ...OrderPrice\n      }\n    }\n    subtotal {\n      ...OrderPrice\n    }\n    total {\n      ...OrderPrice\n    }\n    shippingPrice {\n      ...OrderPrice\n    }\n    discount {\n      amount\n      currency\n    }\n  }\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  fragment OrderPrice on TaxedMoney {\n    gross {\n      amount\n      currency\n    }\n    net {\n      amount\n      currency\n    }\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import gql from "graphql-tag";
import { checkoutAddressFragment, checkoutProductVariantFragment } from "./checkout";
export var orderPriceFragment = gql(_templateObject());
export var orderDetailFragment = gql(_templateObject2(), orderPriceFragment, checkoutAddressFragment, checkoutProductVariantFragment);